import { wuComRoutes } from '@routing/wuComRoutes';
import { useRoutes } from 'react-router-dom';

export const Router = () => useRoutes(wuComRoutes);
